const n = {
  name: "Lightning",
  dimensions: { width: 24, height: 24 },
  content: `
            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.4005 0.0836955C10.8387 0.275222 11.0799 0.750122 10.9762 1.2169L9.24662 8.99997H15C15.3719 8.99997 15.7132 9.20641 15.8858 9.53587C16.0584 9.86533 16.0339 10.2634 15.8222 10.5692L6.82219 23.5692C6.55002 23.9623 6.0376 24.1078 5.59946 23.9163C5.16132 23.7247 4.92009 23.2498 5.02382 22.783L6.75339 15H1C0.628058 15 0.286845 14.7935 0.114223 14.4641C-0.0583987 14.1346 -0.0339042 13.7366 0.17781 13.4308L9.17781 0.430765C9.44999 0.0376174 9.96241 -0.107831 10.4005 0.0836955ZM2.90857 13H8C8.30332 13 8.59025 13.1376 8.78004 13.3742C8.96984 13.6108 9.04199 13.9208 8.97619 14.2169L8.08362 18.2335L13.0914 11H8C7.69668 11 7.40976 10.8623 7.21996 10.6257C7.03017 10.3891 6.95802 10.0791 7.02382 9.78304L7.91639 5.76646L2.90857 13Z" fill="currentColor"/>
    `
};
export {
  n as Lightning
};
